export default "__VITE_ASSET__BUMU8JMm__"